import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NoDataImg from '../../../assets/images/No_data.png';
import styles from './DataTable.module.css';

const AIEduDataTable = (props) => {
    const {
        key,
        data,
        columns,
        selection,
        tableStyle,
        dataKey,
        onSelectionChange,
        emptyMessage,
        className,
        selectionMode,
        scrollHeight,
        isDataSelectable,
        rowClassName,
        footerColumnGroup,
        sortField,
        sortOrder,
        onSort,
        lazy,
        sortIcon,
    } = props;

    return (
        <DataTable
            key={key}
            value={data}
            tableStyle={tableStyle}
            selection={selection}
            onSelectionChange={onSelectionChange}
            dataKey={dataKey}
            className={`mb-6 ${className}`}
            selectionMode='checkbox'
            lazy={lazy}
            emptyMessage={
                emptyMessage && (
                    <div className={styles.no_data}>
                        <div className={styles.no_img}>
                            <img src={NoDataImg} alt='No Data' />
                        </div>
                        <div className={styles.no_data_text}>
                            {emptyMessage}
                        </div>
                    </div>
                )
            }
            scrollable
            scrollHeight={scrollHeight}
            isDataSelectable={isDataSelectable}
            rowClassName={rowClassName}
            footerColumnGroup={footerColumnGroup}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            sortIcon={sortIcon}
            // removableSort
        >
            <Column
                selectionMode={selectionMode}
                headerStyle={{ width: '1rem' }}
            />
            {columns?.map((column) => (
                <Column
                    key={column.field}
                    field={column.field}
                    header={column.header}
                    body={column.body}
                    style={{
                        minWidth: column.minWidth,
                        width: column.width,
                    }}
                    sortable={column.sortable}
                />
            ))}
        </DataTable>
    );
};

export default AIEduDataTable;
